export const TOP_CURRENCY_STATS_TABLE_PAGE_SIZE = 50
